import joinUrl from "../../utils/join-url";
import requestUtility from "../../helpers/request-utility";

const getBillingProfiles = (apiUrl) => () => {
  const url = joinUrl(apiUrl, `/checkoutservice/pb/billing-profiles/`);
  return requestUtility.get(url);
};

export default getBillingProfiles;
